export default {"src":"/_next/static/media/pet-profile-uploading-profile-placeholder-icon.e195970e.svg","height":41,"width":41,"blurWidth":0,"blurHeight":0};